import React from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { DefaultCard, colors } from 'design-system';

// note that 'expired' status is not part of the main model but as an internal mechanism to mark expired quotations
export type StepStatus = 'completed' | 'active' | 'pending' | 'expired';

type Props = {
  title: React.ReactNode;
  subTitle?: React.ReactNode;
  status: StepStatus;
  children?: React.ReactNode;
};

type LocalTheme = {
  disabled: boolean;
};

const useStyles = makeStyles({
  titleText: ({ disabled }: LocalTheme) => ({
    color: disabled ? colors.abbey : colors.madison,
  }),
  captionText: {
    color: colors.abbey,
  },
  content: {
    marginTop: 16,
  },
});

const BaseHistoryStepCard = ({
  title,
  subTitle,
  status,
  children,
}: Props): JSX.Element => {
  const classes = useStyles({
    disabled: ['pending', 'expired'].includes(status),
  });

  return (
    <DefaultCard
      raised={status === 'active'}
      disabled={['pending', 'expired'].includes(status)}
    >
      <Grid container>
        <Grid item xs={11}>
          <Typography variant="body2" className={classes.titleText}>
            {title}
          </Typography>
        </Grid>
        <Grid item xs={1} container justifyContent="flex-end">
          {status === 'completed' && (
            <img data-testid="check" src="/svg/green_check.svg" alt="checked" />
          )}
        </Grid>
        {subTitle && (
          <Grid data-testid="subtitle" item xs={12}>
            <Typography variant="caption" className={classes.captionText}>
              {subTitle}
            </Typography>
          </Grid>
        )}
        <Grid item xs={12} className={classes.content}>
          {children}
        </Grid>
      </Grid>
    </DefaultCard>
  );
};

export default BaseHistoryStepCard;
